import type { TFieldKey } from "@./suf-store";
import { SignupFlowSlug } from "../constants";
import type { RequiredFieldData } from "../../../shared/baseStore.types";

export const requiredFieldsBySlug: Record<
  SignupFlowSlug,
  (data: RequiredFieldData) => TFieldKey[]
> = {
  [SignupFlowSlug.BASIC_INFORMATION]: ({ catId }) => [
    `cat[${catId}].name`,
    `cat[${catId}].gender`,
    `cat[${catId}].breed`,
  ],

  [SignupFlowSlug.AGE]: ({ cat, catId }) => {
    const base: TFieldKey[] = [
      `cat[${catId}].lifeStage`,
      `cat[${catId}].isNeutered`,
      `cat[${catId}].age.mode`,
    ];
    if (cat?.lifeStage === "kitten") {

      const ageMode = cat?.age?.mode ?? "months";
      if (ageMode === "weeks") {
        base.push(`cat[${catId}].age.weeks`);
      } else {
        base.push(`cat[${catId}].age.months`);
      }

    } else {
      // Birthday month is only required for adult/senior cats
      base.push(`cat[${catId}].birthdayMonth`);
      base.push(`cat[${catId}].age.years`);
    }

    return base;
  },

  [SignupFlowSlug.EATING_HABITS]: ({ catId }) => [
    `cat[${catId}].diet.eatingHabits`,
  ],

  [SignupFlowSlug.MOTIVATION]: () => [ "persona" ],

  [SignupFlowSlug.FITNESS]: ({ catId }) => [
    `cat[${catId}].body.bodyType`,
    `cat[${catId}].body.activityLevel`,
  ],

  [SignupFlowSlug.WEIGHT]: ({ cat, catId }) => {
    const base: TFieldKey[] = [
      `cat[${catId}].weight.unit`,
    ];

    if (cat?.weight?.unit === "LB") {
      base.push(`cat[${catId}].weight.valueInLb`);
    } else {
      base.push(`cat[${catId}].weight.valueInKg`);
    }

    return base;
  },

  [SignupFlowSlug.CURRENT_DIET]: ({ catId }) => [
    `cat[${catId}].diet.current.type`,
    `cat[${catId}].diet.current.brand`,
  ],

  [SignupFlowSlug.MEDICAL_CONDITIONS]: ({ cat, catId }) => {
    const base: TFieldKey[] = [ `cat[${catId}].medical.hasConditions` ];
    if (cat?.medical?.hasConditions) {
      base.push(`cat[${catId}].medical.conditions`);
    }
    return base;
  },

  [SignupFlowSlug.ALLERGIES]: ({ cat, catId }) => {
    const base: TFieldKey[] = [ `cat[${catId}].diet.foodAllergies.hasAllergies` ];
    if (cat?.diet?.foodAllergies?.hasAllergies) {
      base.push(`cat[${catId}].diet.foodAllergies.allergens`);
    }
    return base;
  },

  [SignupFlowSlug.CAT_PARENT_DETAILS]: () => [
    "firstName",
    "lastName",
    "email",
  ],

  [SignupFlowSlug.CHECKOUT]: () => [
    "firstName",
    "lastName",
    "email",
    "shippingAddress.postcode",
    "shippingAddress.address1",
    "shippingAddress.city",
    "shippingAddress.province",
    "shippingAddress.phoneNumber",
    "billingAddress.postcode",
    "billingAddress.address1",
    "billingAddress.city",
    "billingAddress.countryCode",
    "billingAddress.phoneNumber",
    "deliveryDate",
  ],

  [SignupFlowSlug.PRICING]: () => [],

  [SignupFlowSlug.RECIPES]: ({ catId }) => [
    `cat[${catId}].viewedPlan`,
  ],
  [SignupFlowSlug.WHY_FRESH]: () => [],
  [SignupFlowSlug.TREATS]: () => [],
  [SignupFlowSlug.CAT_COUNT]: () => [],
};
